import React from "react";
import "./TakingNextLevelStyle.scss";
import { takingNextLevelTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const TakingNextLevelSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="taking-next-level-section">
      <div className="taking-next-level-wrap">
        <SectionHeading>{takingNextLevelTextContent.headingText}</SectionHeading>

        <div className="taking-next-level-box">
          <div className="animation-wrap">
            <img src={takingNextLevelTextContent.imageSrc} alt="Image" />
          </div>
          
          <p className="para-text">{takingNextLevelTextContent.paraText}</p>

          <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={takingNextLevelTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TakingNextLevelSection;
